module.exports = __webpack_public_path__ + "img/instructor.d8ceada0.png";